import { z } from 'zod';
export const shareOrderSchema = z.object({
    email: z.string().trim().max(254).email(),
});
//# sourceMappingURL=order-share.js.map